var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"avatar-wrapper",class:_vm.size != undefined ? _vm.size : ''},[(_vm.avatarURL != undefined)?_c('img',{attrs:{"src":_vm.avatarURL,"alt":"Profile picture"}}):(_vm.fullName != undefined)?_c('span',[_vm._v(_vm._s(_vm.getNameInitials(_vm.fullName)))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }